import z from "zod";

const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

export const loginFormSchemas = z
    .object({
        email: z
            .string()
            .nonempty("Email is required.")
            .email("Invalid email address.").trim(),

        password: z
            .string()
            .nonempty("Password is required")
            .min(8, "Password must be at least 8 characters long.")
            .regex(
                strongPasswordRegex,
                "Password must include at least one uppercase letter, one lowercase letter, one number, and one special character."
            ),
    })


export type LoginFormSchema = z.infer<typeof loginFormSchemas>;
